<base-config #baseConfigRef></base-config>
<bfc-lazy-loader *ngIf="showLazyloader"></bfc-lazy-loader>

<base-login-module
*ngIf="isAvaliable"
(login-router-event)="handleComponentRoute($event)"
(translation-changed)="languageChangeEvent($event)"
[appTranslation]="translation"
[loginInputs]="loginInputs"
[loginConfigData]="loginConfigData"
[socialButtons]="socialButtons"
[loginButtonText]="loginButtonText"
[landingConfig]="langingPageConfig"
(nav-router-event)="handleComponentRoute($event)"
[handleSuccesLoginData]="true"
[logo]="logo"
[logoUrl]="logoUrl"
[allCategories]="allCategories"
[gotoContext]="fetchCategories"
[productId]="productId"
></base-login-module>
